// extracted by mini-css-extract-plugin
export default {"hideSidebar":"styles_hideSidebar__S2HGB","header":"styles_header__9u16s"};